import { SyncDescriptor } from 'vscode/vscode/vs/platform/instantiation/common/descriptors';
import { ExplorerService } from './vscode/src/vs/workbench/contrib/files/browser/explorerService.js';
import { IExplorerService } from 'vscode/vscode/vs/workbench/contrib/files/browser/files.service';
import './vscode/src/vs/workbench/contrib/files/browser/fileCommands.js';
import './vscode/src/vs/workbench/contrib/files/browser/fileActions.contribution.js';
import './vscode/src/vs/workbench/contrib/files/browser/files.contribution._explorer.js';

function getServiceOverride() {
    return {
        [( IExplorerService.toString())]: new SyncDescriptor(ExplorerService, [], true)
    };
}

export { getServiceOverride as default };
